// extracted by mini-css-extract-plugin
export default {"tabletImg":"xH","desktopImg":"yH","mobileImg":"zH","backgroundImage":"AH","content":"BH","rtbLeft":"CH","rtbRight":"EH","imageContainer":"FH","rtbBox":"GH","line":"HH","rtbLeftMobile":"IH","rtbDesktop":"JH"};
    if(module.hot) {
      // 1721922364470
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  